<script setup lang="ts">
  import { useAuth } from '~renderer/composables/useAuth'

  const { signIn } = useAuth()
</script>

<template>
  <div class="flex min-h-[calc(100vh-80px)] items-center justify-center bg-[#292230]">
    <div class="w-full max-w-md rounded-xl border border-[#3b3541] bg-[#211b27] p-8 shadow-2xl">
      <h1
        class="mb-8 bg-linear-to-r from-green-400 to-emerald-600 bg-clip-text text-center text-3xl font-bold text-transparent"
      >
        Welcome Back
      </h1>
      <p class="mb-8 text-center text-gray-400">Sign in to manage your islands and join queues.</p>

      <div class="flex flex-col gap-4">
        <button
          @click="signIn('discord')"
          class="group relative flex w-full cursor-pointer items-center justify-center gap-3 overflow-hidden rounded-lg bg-[#5865F2] px-6 py-3 font-bold text-white transition-all hover:bg-[#4752c4] hover:shadow-lg hover:shadow-[#5865F2]/20 active:scale-[0.98]"
        >
          <i-fa7-brands-discord class="text-xl transition-transform group-hover:rotate-12" />
          <span>Sign in with Discord</span>
        </button>

        <button
          @click="signIn('twitch')"
          class="group relative flex w-full cursor-pointer items-center justify-center gap-3 overflow-hidden rounded-lg bg-[#9146FF] px-6 py-3 font-bold text-white transition-all hover:bg-[#7d3bd9] hover:shadow-lg hover:shadow-[#9146FF]/20 active:scale-[0.98]"
        >
          <i-fa7-brands-twitch class="text-xl transition-transform group-hover:rotate-12" />
          <span>Sign in with Twitch</span>
        </button>

        <button
          @click="signIn('patreon')"
          class="group relative flex w-full cursor-pointer items-center justify-center gap-3 overflow-hidden rounded-lg bg-[#FF424D] px-6 py-3 font-bold text-white transition-all hover:bg-[#E63B45] hover:shadow-lg hover:shadow-[#FF424D]/20 active:scale-[0.98]"
        >
          <i-fa7-brands-patreon class="text-xl transition-transform group-hover:rotate-12" />
          <span>Sign in with Patreon</span>
        </button>
      </div>
    </div>
  </div>
</template>
